import { action, makeObservable, observable, runInAction } from 'mobx';
import type {
  FieldModalCollectionOption,
  FieldModalCollectionOptionsLoader,
} from '../types/FieldsSource';

export class CustomFieldCollectionOptionsState {
  options: FieldModalCollectionOption[] = [];
  loading = false;
  error: unknown = undefined;
  private loaderRef: FieldModalCollectionOptionsLoader | undefined = undefined;
  private readonly cache = new Map<
    FieldModalCollectionOptionsLoader,
    FieldModalCollectionOption[]
  >();

  constructor() {
    makeObservable(this, {
      options: observable.ref,
      loading: observable.ref,
      error: observable.ref,
      clearError: action.bound,
      load: action.bound,
    });
  }

  clearError() {
    this.error = undefined;
  }

  async load(loader: FieldModalCollectionOptionsLoader | undefined) {
    if (!loader) {
      this.loaderRef = undefined;
      this.options = [];
      this.loading = false;
      this.error = undefined;

      return;
    }

    const cached = this.cache.get(loader);
    this.loaderRef = loader;

    if (cached) {
      this.options = cached;
      this.loading = false;
      this.error = undefined;

      return;
    }

    this.options = [];
    this.loading = true;
    this.error = undefined;

    try {
      const options = await loader();

      runInAction(() => {
        this.cache.set(loader, options);

        if (this.loaderRef === loader) {
          this.options = options;
          this.loading = false;
        }
      });
    } catch (error) {
      runInAction(() => {
        if (this.loaderRef === loader) {
          this.options = [];
          this.loading = false;
          this.error = error;
        }
      });
    }
  }
}
